import React from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

function DeleteDialog({ onDelete, onCancel, title, cancel, deletes }: any) {
  const actionLabel = deletes ?? "DEACTIVE";
  const isDelete = String(actionLabel).toUpperCase().includes("DELETE");

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-dialog-title"
      onClick={() => onCancel()}
    >
      <div
        className="relative w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl dark:border-slate-600 dark:bg-slate-800"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-rose-500 via-red-500 to-orange-500" />

        <div className="flex justify-end px-4 pt-4">
          <button
            type="button"
            onClick={() => onCancel()}
            className="flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-slate-700 dark:hover:text-slate-200"
            aria-label="Close"
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </button>
        </div>

        <div className="flex flex-col items-center px-6 pb-2 text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 ring-8 ring-red-50/60 dark:bg-red-900/30 dark:ring-red-900/20">
            {isDelete ? (
              <DeleteOutlineIcon
                className="text-red-500 dark:text-red-400"
                sx={{ fontSize: 28 }}
              />
            ) : (
              <WarningAmberRoundedIcon
                className="text-red-500 dark:text-red-400"
                sx={{ fontSize: 28 }}
              />
            )}
          </div>

          <h2
            id="delete-dialog-title"
            className="text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-100"
          >
            {isDelete ? "Delete record?" : "Deactivate record?"}
          </h2>
          <p className="mt-2 max-w-sm text-sm leading-relaxed text-slate-500 dark:text-slate-400">
            {title ??
              "Are you sure you want to deactivate this patient's record?"}
          </p>
        </div>

        <div className="mt-6 flex flex-col-reverse gap-2 border-t border-slate-100 bg-slate-50/80 px-5 py-4 sm:flex-row sm:justify-end dark:border-slate-700 dark:bg-slate-900/40">
          <button
            type="button"
            onClick={() => onCancel()}
            className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-100 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            {cancel ?? "Cancel"}
          </button>
          <button
            type="button"
            onClick={() => onDelete()}
            className="inline-flex items-center justify-center gap-1.5 rounded-xl bg-red-500 px-4 py-2.5 text-sm font-medium text-white shadow-sm shadow-red-500/25 transition-colors hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500/30 dark:bg-red-600 dark:hover:bg-red-500"
          >
            <DeleteOutlineIcon sx={{ fontSize: 16 }} />
            {actionLabel.charAt(0) + actionLabel.slice(1).toLowerCase()}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteDialog;
